import { Controller } from "stimulus";
import {
  getActiveCurrency,
  formatCurrency,
} from "../../util/currency";
import {
  stockChartOptions,
  HIGHCHARTS_DATE_FORMAT,
} from "../../config";
import { getPortfolioOverviewChart } from "../../routes/portfolio";
import CoinGeckoThumbnailImage from "images/coingecko-greyscale.png";
import { EventPortfolioOverviewChart } from "../../events";

export default class extends Controller {
  static targets = ["chart", "chartLoading", "chartButton"];

  connect() {
    const params = {
      portfolioId: this.portfolioId,
      vs_currency: getActiveCurrency(),
      timeframe: "7d",
    };

    this._showLoadingBar();
    window.addEventListener(EventPortfolioOverviewChart, () => {
      getPortfolioOverviewChart(params, (result) => this._renderChart(result.data))
    });
  }

  get portfolioId() {
    return this.data.get("portfolioId");
  }

  updateChart(e) {
    const button = e.currentTarget,
          params = {
                      portfolioId: this.portfolioId,
                      vs_currency: getActiveCurrency(),
                      timeframe: button.dataset.timeframe,
                    };

    this._setActiveButton(button);
    this._showLoadingBar();

    getPortfolioOverviewChart(params, (result) => this._renderChart(result.data));
  }

  _setActiveButton(button) {
    if (!button) return;

    this.chartButtonTargets.forEach((target) => target.classList.remove("active"));
    button.classList.add("active")
  }

  _showLoadingBar() {
    this.chartLoadingTarget.classList.remove("tw-hidden");
  }

  _hideLoadingBar() {
    this.chartLoadingTarget.classList.add("tw-hidden");
  }

  _renderChart(data) {
    console.log("rendering chart")
    const title = "Portfolio Overview";

    Promise.all([import("highcharts/highstock")]).then(res => {
      const [Highcharts] = res;
      const chartOptions = Object.assign(stockChartOptions(this.chartTarget.id), {
        time: { useUTC: false },
        legend: {
          enabled: false,
        },
        chart: {
          zoomType: 'x',
          type: "line",
          height: 350,
          renderTo: this.chartTarget.id,
          className: "cg-highcharts"
        },
        credits: {
          enabled: false,
        },
        navigator: {
          enabled: false,
        },
        title: title,
        xAxis: {
          type: "datetime",
          title: {
            enabled: false
          }
        },
        yAxis: {
          title: {
            text: `${getActiveCurrency().toUpperCase()}`,
            style: {
              color: "#56b4e9",
            },
          },
          showLastLabel: true,
          opposite: false,
          labels: {
            align: "left",
            y: -5,
            x: 4,
            style: {
              color: "#56b4e9",
            },
            formatter: function() {
              return `${formatCurrency(this.value, getActiveCurrency())}`;
            }
          }
        },
        plotOptions: {
          series: {
            marker: false,
          },
        },
        series: [{
            name: title,
            data: data,
            color: "#428bca",
        }],
        tooltip: {
          shared: true,
          formatter() {
            const date = this.points[0].series.chart.time.dateFormat(
              HIGHCHARTS_DATE_FORMAT,
              this.points[0].x
            );
            let formatter = `${date}<br/>`;

            this.points.forEach(point => {
              formatter += `
                <span style='color:${point.color}'>\u25CF</span>
                ${point.series.name}:
                <b>${formatCurrency(point.y, getActiveCurrency())}</b><br/>
              `;
            });

            return formatter;
          }
        }
      });

      const chart = Highcharts.chart(chartOptions);
      chart.renderer.image(
        CoinGeckoThumbnailImage,
        chart.chartWidth - 115,
        chart.chartHeight - 80,
        100,
        28
      ).add();

      this._hideLoadingBar();
    });
  }
}
